import McTable from './McTable.vue'

McTable.install = function(Vue){
    Vue.component(McTable.name, McTable);
}

export default McTable;